import { combineReducers } from "redux";
import authToken from "./authToken";
import wallet from "./walletReducer";

export default combineReducers({
    authToken:authToken,
    wallet: wallet
});